'use client';

function easeInOutSine(x) {
    return -(Math.cos(Math.PI * x) - 1) / 2;
}
function easeOutElastic(x) {
    var c4 = (2 * Math.PI) / 3;
    return x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * c4) + 1;
}
function easeInOutCirc(x) {
    return x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2;
}
var animation = {
    easeInOutSine: easeInOutSine,
    easeOutElastic: easeOutElastic,
    easeInOutCirc: easeInOutCirc
};

export { animation as default };
//# sourceMappingURL=animation.js.map
